import React, { useState } from 'react';
import './FormSection.css';

/**
 * FormSection Component
 * Container/divider for grouping form fields
 * 
 * @param {string} title - Section title
 * @param {string} description - Section description
 * @param {ReactNode} children - Section content
 * @param {boolean} collapsible - Allow section to be collapsed (default: false)
 * @param {boolean} defaultCollapsed - Default collapsed state (default: false)
 * @param {string} className - Additional CSS classes
 */
const FormSection = ({
  title,
  description,
  children,
  collapsible = false,
  defaultCollapsed = false,
  className = ''
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    if (collapsible) {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className={`form-section ${className}`.trim()}>
      {(title || description) && (
        <div 
          className={`form-section-header ${collapsible ? 'collapsible' : ''}`}
          onClick={handleToggle}
        >
          {title && (
            <h3 className="form-section-title">
              {title}
              {collapsible && (
                <span className={`form-section-arrow ${isCollapsed ? 'collapsed' : ''}`}>
                  ▼
                </span>
              )}
            </h3>
          )}
          {description && (
            <p className="form-section-description">{description}</p>
          )}
        </div>
      )}
      <div className={`form-section-content ${isCollapsed ? 'collapsed' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default FormSection;










